import Login from '../components/Login';
import InfoManager from '../components/content/InfoManager';
import InfoForm from '../components/content/form/InfoForm';
import PostersManager from '../components/content/PosterManager';
import PosterForm from '../components/content/form/PosterForm';
import CategoriesManager from '../components/content/CategoriesManager';
import CategoriesForm from '../components/content/form/CategoriesForm';
import UsersForm from '../components/content/form/UsersForm';
import UsersManager from '../components/content/UsersManager';
export const privateRoute = [
   {path: '/info', element: <InfoManager/>},
   {path: '/info/:id', element: <InfoForm/>},
   {path: '/posters', element: <PostersManager/>},
   {path: '/posters/:id', element: <PosterForm/>},
   {path: '/users', element: <UsersManager/>},
   {path: '/users/:id', element: <UsersForm/>},
   {path: '/categories', element: <CategoriesManager/>},
   {path: '/categories/:id', element: <CategoriesForm/>},

]

export const publicRoute = [
   {path: '/login', element: <Login/>},
]
